import firebase, { database } from "../firebase";
import * as actionTypes from "../actionTypes";
import * as constants from "../Constatnts";
import axios from "axios";

export function getPaymentTypes(registrationID) {
  return async (dispatch, getState) => {
    // let addMessage = firebase.functions().httpsCallable("apiGetPaymentTypes");
    // return addMessage({ registrationID: registrationID }).then(function(
    //   result
    // ) {
    //   let paymentTypes = result.data;
    //   dispatch({ type: actionTypes.PAYMENT_TYPES_GET, paymentTypes });
    // });
    const token = getState().user.uat;
    const response = await axios.get(constants.API_URL + "/setup/paymenttype", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (response && response.data && response.data.paymentTypes) {
      let paymentTypes = response.data.paymentTypes;
      dispatch({ type: actionTypes.PAYMENT_TYPES_GET, paymentTypes });
      return paymentTypes;
    }
  };
}


export function deletePaymentType(key) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;

      const response = await axios.delete(
        constants.API_URL + "/setup/paymenttype/" + key,
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      );

      if (
        response &&
        response.hasOwnProperty("data") &&
        response.data.hasOwnProperty("code") &&
        response.data.code === "0"
      ) {
        return true;
      } else {
        let message = "Failed to delete payment type";

        if (
          response &&
          response.hasOwnProperty("data") &&
          response.data.hasOwnProperty("message")
        ) {
          message = response.data.message;
        }

        alert(message);
        return false;
      }
    } catch (error) {
      console.error("Delete role error:", error);

      let message = "Error while deleting payement type";

      if (
        error &&
        error.hasOwnProperty("response") &&
        error.response.hasOwnProperty("data") &&
        error.response.data.hasOwnProperty("message")
      ) {
        message = error.response.data.message;
      }

      alert(message);
      return false;
    }
  };
}
// export function deletePaymentType(key) {
//   return (dispatch, getState) => {
    
//     return database
//       .collection("PaymentTypes")
//       .doc(key)
//       .update({
//         ActionOn: firebase.firestore.FieldValue.serverTimestamp(),
//         ActionBy: getState().user.user.Name,
//         ActionByUID: getState().user.user.UID,
//         ActionByEmailID: getState().user.user.EmailID,
//         Action: constants.AUDIT_TRAIL_DELETE,
//         IsDeleted: true,
//       })
//       .then(() => {
//         return true;
//       });
//   };
// }



export function savePaymentType(paymentType, key) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      let response = {};

      if (key !== "") {
        // Update existing account
        response = await axios.put(
          `${constants.API_URL}/setup/paymenttype/${key}`,
          paymentType,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      } else {
        // Create new account
        response = await axios.post(
          `${constants.API_URL}/setup/paymenttype`,
          paymentType,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      }

      if (response.data.code === "0") {
        if (key) {
          return key;
        } else {
          return response.data.data.key;
        }
      }

      return null;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}
